export var eventRegion = function eventRegion(_config, _data, globalConfig) {
  return {
    'event:region': "".concat(globalConfig.region)
  };
};